<atlas-panel-header>
  <div header i18n="@@propertiesHeader">Properties</div>
  <div description i18n="@@swipeLeftReportsDescription">
    Swipe left to access the Reports panel
  </div>
</atlas-panel-header>

@if (
  (canShowPropertiesPanel$ | async) && !(isProfilerFeatureSelected$ | async)
) {
  <mat-divider></mat-divider>
  <div class="location-info-container">
    <atlas-location-panel
      [address]="(selectedPoint$ | async)?.address"
      [selectedLocation]="(selectedPoint$ | async)?.location"
      [isSupplyPoint]="isSupplyPoint$ | async"
      [isSupplyPointClosed]="isSupplyPointClosed$ | async"
      [isNetworkPlanningReadonlySystem]="
        isNetworkPlanningReadonlySystem$ | async
      "
      [selectedSupplyPoint]="originalSelectedSupplyPoint$ | async"
      [areMultipleLocationsSelected]="areMultipleLocationsSelected$ | async"
    ></atlas-location-panel>
  </div>
}

@if (!(isProfilerFeatureSelected$ | async)) {
  <mat-divider></mat-divider>
}

<div>
  @if (
    (canShowPropertiesPanel$ | async) && !(isProfilerFeatureSelected$ | async)
  ) {
    <div>
      @if (isSMFeatureSelected$ | async) {
        <atlas-spatial-modeller-properties></atlas-spatial-modeller-properties>
      }
      @if (isLocatorFeatureSelected$ | async) {
        <atlas-locator-properties
          [areMultipleLocationsSelected]="areMultipleLocationsSelected$ | async"
        ></atlas-locator-properties>
      }
    </div>
  }
  @if (
    (isProfilerFeatureSelected$ | async) &&
    (profilerStatus$ | async) === 'ReportAggregateCompleted'
  ) {
    <atlas-profiler-properties></atlas-profiler-properties>
  }
</div>
